<template>
	<div class='route_container pt-2'>
		<!-- Giveaways New -->
		<div class="bg-gradient py-1 px-5 mt-5 hero_section">			
			<div class="hero_section__summary py-1 px-5">
				<h6 class="mb-0"> {{ $t('gifts_giveaways') }} > {{ $t('gifts_new') }} </h6>
			</div>
		</div>
		<div class="main_container px-5 py-3">
			<div class="row">	
				<div class="col-lg-2"></div>
				<div class="col-lg-8 pl-lg-3 px-0 pb-3">
                    <div class="bg-gray-900 border border-green-lighter mt-3 px-3">
                        <div class="markdown py-1">
                        	<p>
								<font-awesome-icon icon="check-circle"/> &nbsp;&nbsp;
								<span class="pr-1">{{ $t('gifts_can_create') }} 25 {{ $t('gifts_gifts') }} {{ $t('gifts_based_on_feedback') }}</span>
							</p>
                        </div>
                    </div>
					<!-- giveway list -->
					<div @submit.prevent='createGiveaway'>
						<div class="comments border border-green-lighter my-3 px-3">
							<div class="comments">
								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">1. {{ $t('gifts_select_a_game') }}</a>
										</div>									
									</div>
									<div class="comment__children">
										<div class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">
													<fancy-input
														:placeholder='$t("gifts_type_name")'
														aria-label="Search"
														ref="search"
														v-model="searchKeys"
														:large='true'
														:error='error.selectGameError'
													></fancy-input>
													<!-- Games list -->													
											<div v-if="showTbl" class="table mb-0">												
												<div class="table__row-inner-wrap" 
														v-for='(game, $index) in drawGamedata'
														:key='$index'
														@click="selectGame(game.id_idcgame, game)"
														>
													<div>														
														<div class="d-flex flex-row flex-wrap mx-0">
															<div class="game-card-rectangular" >
																<div class="d-flex flex-row">
																	<div class="d-flex align-items-center justify-content-center position-relative">
																		<div class="position-relative">
																			<div class="overlay">
																				<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="game.game_logo"  alt="--">
																			</div>
																			<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
																				<img class="gameCard-img" :src="game.game_banner" alt="...">
																			</div>
																		</div>
																	</div>												
																</div>
															</div>
														</div>
													</div>
													<div class="table__column--width-fill">
														<span>{{ game.game_name}}</span> 
														<span v-if="game.value_type==='reduced'" class="text-danger"> *</span>
														<span v-if="game.value_type==='no'" class="text-danger"> **</span>
														<br>
														<a :href="`https://${$store.state.meta.lang}.idcgames.com/${game.game_seo}`"
															style="color: #00ff7f"
															target="_blank">
															{{ `https://${$store.state.meta.lang}.idcgames.com/${game.game_seo}` }}
														</a>
													</div>
													<div v-if="game.KeyIdc.length" class="pr-1">
														<span class="text-primary"> 
															<font-awesome-icon :icon="['fa','key']" />
															{{ game.KeyIdc.length }} Key
														</span>
													</div>
												</div>
											</div>
											<loading-button
												v-if="loadingAPI"
												:loading='loadingAPI'
												class='nav-link'
											>
												<font-awesome-icon icon="spinner"/>
											</loading-button>
													<div class="pt-2" style="font-size: 10pt">
														<span class="text-white"> * </span>{{ $t('gifts_2_letters_search') }}
													</div>
													<div class="pt-2 d-none" style="font-size: 10pt">
														<span class="text-danger"> * </span>: {{ $t('gifts_reduce_value_text') }}
													</div>
													<div class="d-none" style="font-size: 10pt">
														<span class="text-danger"> ** </span>: {{ $t('gifts_no_value_text') }}
													</div>
												</div>
											
											</div>										
										</div>
									</div>
								</div>

								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">2. {{ $t('gifts_list_of_keys') }}</a>
										</div>										
									</div>									
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">												
													<div>
														<!-- <select v-model="keySelect" class="form-control form-select" multiple>
															<option v-for="(code, $index) in keyLists" 
																	class="px-2" 
																	:value="code" 
																	:key="$index" selected>
																{{ code }}
															</option>
														</select> -->
														<!-- <div v-for="(code , $index) in keyLists" :key="$index">{{ code }}</div> -->
														<ul class="rder px-2">
															<li v-for="(data, $index) in keyLists" 
																class="d-flex align-items-center border-bottom py-1"
																:key='$index'
																>
																<span>{{ data.code }}</span> 
																<input  type="checkbox" 
																		class="ml-auto mr-5 redborder"
																		@change="checkCode(data.code, !data.select)"  
																		:checked='data.select' />
															</li>															
														</ul>
														<div v-if="error.NotKeyCode" class="text-danger">*{{ $t('gifts_no_keys')}}</div>
														<div v-if="error.keycode" class="text-danger">*{{ $t('gifts_select_keys') }}</div>
														<div v-if="keyLists.length" class="pt-2" style="font-size: 10pt">{{ keyLists.length }} Key found.</div>														
													</div>												
												</div>
											</div>										
										</div>
									</div>
								</div>
								
								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">3. {{ $t('gifts_time_range') }}</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">
													<div class="col-lg-12 d-flex">
														<div class="d-inline">
															<div>{{ $t('gifts_start') }}</div>
															<vc-date-picker v-model="sDate" mode="dateTime" is24hr>
																<template v-slot="{ inputValue, inputEvents }">
																	<input
																	class="px-2 py-1 rounded focus:outline-none focus:border-blue-300"
																	:value="inputValue"
																	v-on="inputEvents"
																	:class='{
																		"border": !error.dateRanger,
																		"border-danger": error.dateRanger
																		}'
																	/>
																</template>
															</vc-date-picker>
														</div>
														<div class="d-inline pl-4">
															<div>{{ $t('gifts_end') }}</div>
															<vc-date-picker v-model="eDate" mode="dateTime" is24hr>
																<template v-slot="{ inputValue, inputEvents }">
																	<input
																	class="px-2 py-1 rounded focus:outline-none focus:border-blue-300"
																	:value="inputValue"
																	v-on="inputEvents"
																	:class='{
																		"border": !error.dateRanger,
																		"border-danger": error.dateRanger
																		}'
																	/>
																</template>
															</vc-date-picker>
														</div>
													</div>
													<div v-if="error.dateRanger" class="text-danger col-lg-12 pt-1">
														*{{ $t('gifts_valid_time_period') }}
													</div>
													<div class="pt-2"></div>
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">4. {{ $t('gifts_region_restriction') }}</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">												
													<div>
														<label class="redborder">
															<input type="radio" value="no" v-model="region">
															<span class="pl-4">{{ $t('gifts_no') }}</span>
														</label>
													</div>

													<div>
														<label class="redborder">
															<input type="radio" value="yes" v-model="region" @click="sltCountry">
															<span class="pl-4">{{ $t('gifts_yes') }}</span>
														</label>
													</div>
													<!-- Country flags -->
													<div v-if="region=='yes'" class="ml-4">
														<div class="d-flex mb-3">
															<fancy-input
																:placeholder='$t("gifts_search_countries")'
																aria-label="Search"
																ref="search"
																v-model="searchCountries"
																:large='false'
																width='25%'
																:error='error.selectCountryError'
															></fancy-input>	
															<button class="btn btn-sm ml-auto slt" style="color: white" @click="selCountryAll">{{ $t('gifts_select_all') }}</button>
															<button class="btn btn-sm ml-auto slt" style="color: white" @click="unSelCountryAll">{{ $t('gifts_select_none') }}</button>
														</div>
														<ul class="border px-2" id="country-container">
															<li v-for="(data, $index) in cData.filter( x => x.cname.toLowerCase().includes(searchCountries.toLowerCase()) )" 
																class="d-flex align-items-center border-bottom"
																:key='$index'
																>
																<country-flag :country='data.code' size='normal'/>
																<span>{{ data.cname }}</span> 
																<input  type="checkbox" 
																		class="ml-auto mr-4 redborder"
																		@change="checkCountry(data.cname,!data.select)"  
																		:checked='data.select' />
															</li>															
														</ul>
													</div>
													<!-- <div class="pt-2"></div> -->
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">5. {{ $t('gifts_who_can_enter') }}</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">												
													<div>
														<label class="redborder">
															<input type="radio" value="all" v-model="whocanenter">
															<span class="pl-4">{{ $t('gifts_everyone') }}</span>
														</label>
													</div>

													<div>
														<label class="redborder">
															<input type="radio" value="invite" v-model="whocanenter">
															<span class="pl-4">{{ $t('gifts_invite_only') }}</span>
														</label>
													</div>

													<div>
														<label class="redborder">
															<input type="radio" value="wgroup" v-model="whocanenter">															
															<span class="pl-4">{{ $t('gifts_whitelist') }} ( {{ wgData.length }} {{ $t('gifts_members') }} )</span>
														</label>
													</div>
													<!-- whitelist/Groups -->
													<div v-if="whocanenter=='wgroup'" class="ml-4 d-none">
														<div class="d-flex">
															<fancy-input
																:placeholder='`${ $t("gifts_search") }...`'
																aria-label="Search"
																ref="search"
																v-model="wGroups"
																:large='false'
																width='25%'
																:error='error.selectWGError'
																class="mb-3"
															></fancy-input>	
															<button class="btn btn-sm ml-auto slt" style="color: white" @click="selWGroupsAll">{{ $t('gifts_select_all') }}</button>
															<button class="btn btn-sm ml-auto slt" style="color: white" @click="unSelWGroupsAll">{{ $t('gifts_select_none') }}</button>
														</div>
														<ul class="border px-2" id="white-list-container">
															<li v-for="(data, $index) in wgData.filter( x=>x.username.toLowerCase().includes(wGroups.toLowerCase()) )" 
																class="d-flex align-items-center border-bottom"
																:key='$index'
																>
																<div class="table__row-inner-wrap d-flex align-items-center">
																	<div>
																		<router-link 
																			:to="`/${$store.state.meta.lang}/user/${data.username}`"
																			class="giveaway_image_avatar my-2" 
																			:style="data.profile_photo_path?
																			{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/'+ data.profile_photo_path + ')' }:
																			{ 'background-image': 'url(' + missed_avatar + ')' }">
																		</router-link>
																	</div>																	
																	<div class="table__column--width-medium">
																		<div>
																			<p>{{ data.username }}</p>
																			<small></small>
																		</div>																	
																	</div>
																</div>

																<input	type="checkbox" 
																		class="ml-auto mr-4 redborder" 
																		@change="checkGroups(data.username, data.select)"
																		:checked='data.select'/>
															</li>															
														</ul>
													</div>
													<!-- <div class="pt-2" style="font-size: 10pt">*{{ $t('gifts_select_the_users') }}</div> -->
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">6. {{ $t('gifts_contributor_level') }}</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">												
													<div class="mx-2">
														<VueSlideBar class="mx-2" 
																	v-model="slider.value" 
																	:data="slider.data" 
																	:range="slider.range"
																	:min="0" 
																	:max="100"/>
													</div>												
													<div class="pt-2 d-none" style="font-size: 10pt">*{{ $t('gifts_no_contributor_level') }} </div>
												</div>
											</div>										
										</div>
									</div>
								</div>
								
								<div class="comment">
									<div class="ajax comment__parent">									
										<div class="comment__author">
											<a href="javascript:void(0)">7. {{ $t('gifts_description') }} ( {{ $t('gifts_optional') }} )</a>
										</div>										
									</div>
									<div class="comment__children">
										<div data-comment-id="58216281" class="comment">
											<div class="ajax comment__child">											
												<div class="comment__summary">												
													<div>
														<textarea class="form-control" v-model="description"></textarea>
													</div>												
												</div>
											</div>										
										</div>
									</div>
								</div>

								<div v-if="final" class="row pb-2">
									<div v-if="error.final" class="text-danger col-12 p-0 mb-1">*{{ $t('gifts_check_all_the_fields') }}</div>									
									<button class="btn btn-primary btn-md rounded w-25" @click="reviewGiveaway">										
										<span v-if="!creationLoading">
											<font-awesome-icon  icon="arrow-right"/>
											<span class="pl-3">{{ $t('gifts_review_giveaway') }}</span>
										</span>
									</button>
								</div>

								<!-- reminder =>> -->
								<div v-else class="row pb-2">
									<div class="border mb-4 col-12">
										<div class="col-12 pt-2">
											<label class="review-label pl-2">1. {{ $t('gifts_select_a_game') }}</label>
											<p class="pl-4">{{ reviewData.gamedata.game_name && reviewData.gamedata.game_name }}</p>
										</div>
										<div class="col-12 pt-2">
											<label class="review-label pl-2">2. {{ $t('gifts_list_of_keys') }}</label>
											<p v-for="(code, i) in reviewData.keycode" :key="i" class="pl-4"> {{code}}</p>
										</div>
										<div class="col-12 pt-2">
											<label class="review-label pl-2">3. {{ $t('gifts_time_range') }}</label>
											<p class="pl-4">Start: {{ reviewData.duration.start }} ~ End: {{ reviewData.duration.end }}</p>
										</div>
										<div class="col-12 pt-2">
											<label class="review-label pl-2">4. {{ $t('gifts_region_restriction') }}</label>
											<p v-if="reviewData.region.select == 'no'" class="pl-4">{{ reviewData.region.select }}</p>
											<div v-else class="border pl-4">												
												<ul class="px-2 overflow-auto" style="max-height: 250px;">
													<li v-for="(el, $index) in reviewData.region.data" 
														class="d-flex align-items-center"
														:key='$index'>
														<country-flag :country='el.code' size='normal'/>
														<span>{{ el.cname }} ( {{ el.code }} )</span>
													</li>															
												</ul>
											</div>
										</div>
										<div class="col-12 pt-2">
											<label class="review-label pl-2">5. {{ $t('gifts_who_can_enter') }}</label>
											<p v-if="reviewData.whocanenter.select != 'wgroup'" class="pl-4">{{ reviewData.whocanenter.select }}</p>
											<div v-else class="border pl-4">												
												<ul class="px-2 overflow-auto" style="max-height: 250px;">
													<li v-for="(data, $index) in reviewData.whocanenter.data" 
														class="d-flex align-items-center"
														:key='$index'>
														<div class="table__row-inner-wrap d-flex align-items-center">
															<div>
																<router-link 
																	:to="`/${$store.state.meta.lang}/user/${data.username}`"
																	class="giveaway_image_avatar my-2" 
																	:style="data.profile_photo_path?
																	{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/'+ data.profile_photo_path + ')' }:
																	{ 'background-image': 'url(' + missed_avatar + ')' }">
																</router-link>
															</div>																	
															<div class="table__column--width-medium pl-2">
																<div>
																	<p>{{ data.username }}</p>
																</div>																	
															</div>
														</div>
													</li>															
												</ul>
											</div>
										</div>
										<div class="col-12 pt-2">
											<label class="review-label pl-2">6. {{ $t('gifts_contributor_level') }}</label>
											<p class="pl-4">{{reviewData.contribute_level}}</p>
										</div>
										<div class="col-12 py-2">
											<label class="review-label pl-2">7. {{ $t('gifts_description') }} ( {{ $t('gifts_optional') }} )</label>
											<p class="pl-4">{{ reviewData.description}}</p>
										</div>
									</div>
									<a class="btn btn-primary btn-md rounded mr-2 w-25" @click="final=!final">
										<loading-button
											v-if="creationLoading"
											:loading='creationLoading'
											class='nav-link'
										>
											<font-awesome-icon icon="spinner"/>
										</loading-button>										
										<span v-if="!creationLoading">
											<font-awesome-icon  icon="arrow-left"/>
											<span class="pl-3">{{ $t('gifts_reminder') }}</span>
										</span>
									</a>
									<a class="btn btn-primary btn-md rounded w-25" @click="createGiveaway">
										<loading-button
											v-if="creationLoading"
											:loading='creationLoading'
											class='nav-link'
										>
											<font-awesome-icon icon="spinner"/>
										</loading-button>										
										<span v-if="!creationLoading">
											<font-awesome-icon  icon="check-circle"/>
											<span class="pl-3">{{ $t('gifts_publish_giveaway') }}</span>
										</span>
									</a>
								</div>
								<!-- reminder <<== -->
							</div>
						</div>
					</div>					
				</div>
				<div class="col-lg-2"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import InfoTooltip from '../InfoTooltip.vue'
	import {apiDomain} from '../../config'
	import LoadingButton from '../LoadingButton';
	import CountryFlag from 'vue-country-flag'		
	import moment from "moment/moment";

	export default {
		name: 'giveaway',
		components: {
			FancyInput,
			InfoTooltip,
			LoadingButton,
			CountryFlag
		},
		data () {

			Date.prototype.addHours= function(h){
				this.setHours(this.getHours()+h);
				return this;
			}
			let sDate = new Date();
			let eDate = new Date().addHours(1);

			return {
				apiDomain: apiDomain,
				sDate: sDate,
				eDate: eDate,
				region: 'no',
				inputKeys: '',
				searchKeys: '',
				whocanenter: 'all',				
				selectedDate: null,
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				idc_game_id: 0,
				gamedata: {
					game_seo: '',
					game_name: '',
					game_banner: '',
					game_logo: '',
				},
				description: '',				
				showTbl: false,
				drawGamedata: [],
				orgGamedata: [],
				redeemGamedata: [],
				loadingAPI: false,
				creationLoading: false,
				error:{
					selectGameError: '',
					selectCountryError: '',
					selectWGError: '',
					final: false,
					keycode: false,
					NotKeyCode: false,
					dateRanger: false,
				},
				keySelect: [],
				keyLists: [],
				country: {
					region: '',
					country: ''
				},
				cData: [],					
				searchCountries: '',	
				wGroups: '',
				reviewData: {},
				final: true,
				wgData:[],
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				level: `0 ${this.$t('gifts_level')}`,
				slider: {
					value: `0 ${this.$t('gifts_level')}`,
					data: [
						`0 ${this.$t('gifts_level')}`,
						`1 ${this.$t('gifts_level')}`,
						`2 ${this.$t('gifts_level')}`,
						`3 ${this.$t('gifts_level')}`,
						`4 ${this.$t('gifts_level')}`,
						`5 ${this.$t('gifts_level')}`,
						`6 ${this.$t('gifts_level')}`,
						`7 ${this.$t('gifts_level')}`,
						`8 ${this.$t('gifts_level')}`,
						`9 ${this.$t('gifts_level')}`,
						`10 ${this.$t('gifts_level')}`,
					],
					range: [
						{label: `0 ${this.$t('gifts_level')}`},
						{label: `1 ${this.$t('gifts_level')}`},
						{label: `2 ${this.$t('gifts_level')}`},
						{label: `3 ${this.$t('gifts_level')}`},
						{label: `4 ${this.$t('gifts_level')}`},
						{label: `5 ${this.$t('gifts_level')}`},
						{label: `6 ${this.$t('gifts_level')}`},
						{label: `7 ${this.$t('gifts_level')}`},
						{label: `8 ${this.$t('gifts_level')}`},
						{label: `9 ${this.$t('gifts_level')}`},
						{label: `10 ${this.$t('gifts_level')}`}
					]
				}
			}
		},
		methods:{
			utcTime: function(val){		

				return moment(val).utc().format("YYYY-MM-DD HH:mm:ss");
			},
			reviewGiveaway: function(e){
				
				if(!this.idc_game_id) {
					this.error.selectGameError = `${ this.$t('gifts_select_a_game_from_idc') }`
					this.error.final = true
					return;
				}				
				
				if(!this.keyLists.filter(x=>x.select).length){ this.error.keycode = true; this.error.final = true; return;} 
				if(this.sDate >= this.eDate){ this.error.dateRanger = true; this.error.final = true; return;} 

				//keycode
				this.keySelect = [];
				this.keyLists.forEach( x => { if(x.select) this.keySelect.push(x.code) });

				//date region
				let startDate = this.getStandardDate(this.sDate);
				let endDate   = this.getStandardDate(this.eDate);

				//region
				let regionData = this.region==='no' ? [] : this.cData.filter(x => x.select);
				
				//who can enter
				let wcData = this.whocanenter==="wgroup" ? this.wgData.filter( x=> x.select) : [];				

				this.final = false; this.error.keycode = false; this.error.dateRanger = false;
				
				this.reviewData = {	idc_game_id: this.idc_game_id,
									gamedata: this.gamedata, 
									keycode: this.keySelect, 
									duration: {	start: startDate, 
												end: endDate
									}, 
									region: {select: this.region, data: regionData},
									whocanenter: {select: this.whocanenter, data: wcData},
									contribute_level: this.level.split(" ")[0]*1,
									description: this.description,
								}
				
			},
			createGiveaway: function(e){

				if(!this.idc_game_id) {
					this.error.selectGameError = `${ this.$t('gifts_select_a_game_from_idc') }`
					this.error.final = true
					return;
				}

				if(!this.keyLists.filter(x=>x.select).length){ this.error.keycode = true; this.error.final = true; return;} 
				if(this.sDate >= this.eDate){ this.error.dateRanger = true; this.error.final = true; return;} 

				let startDate = this.getStandardDate(this.sDate);
				let endDate   = this.getStandardDate(this.eDate);

				//keycode
				this.keySelect = [];
				this.keyLists.forEach( x => { if(x.select) this.keySelect.push(x.code) });

				//region
				let regionData = this.region==='no' ? [] : this.cData.filter(x => x.select);
				
				//who can enter
				let wcData = this.whocanenter==="wgroup" ? this.wgData.filter( x=> x.select ) : [];

				let data = {	idc_game_id: this.idc_game_id,
								gamedata: this.gamedata, 
								keycode:  this.keySelect, 
								duration: {	start: this.utcTime(startDate), 
											end: this.utcTime(endDate)
								}, 
								region: {select: this.region, data: regionData},
								whocanenter: {select: this.whocanenter, data: wcData},
								contribute_level: this.level.split(" ")[0]*1,
								description: this.description,
								idc_token: this.$cookies.get('token'),
							}
				
				this.creationLoading = true;
				
				this.axios.request({
					method: 'post',
					url: `${apiDomain}/api/v1/giveaway`,
					data: data,
					headers: {
						'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
					}
				}).then(res => {

					this.showTbl = false
					this.creationLoading = false;
					this.$router.push(`/${this.$store.state.meta.lang}/giveaway/created`)

				}).catch(err => {
					
					this.creationLoading = false;						
				})

				
			},
			getStandardDate: function(d){
				return d.getFullYear() + "-" + (d.getMonth()+1) + "-" + d.getDate() +" " + d.getHours() + ":" + d.getMinutes();
			},
			selectGame: function(gID, game){
				this.searchKeys = game.game_name;
				this.idc_game_id = gID;
				this.gamedata = game;			
				//
				// this.keyLists = game.KeyIdc;
				this.keyLists = game.KeyIdc.map( x => {let ss={}; ss["code"]=x; ss['select']=false; return ss;})

				if(this.keyLists.length){
					this.error.NotKeyCode = false;
				}else{
					this.error.NotKeyCode = true;
				}
			},				
			sltCountry: function(){

				this.axios.request({
					method: 'get',
					url: `${apiDomain}/api/v1/country-list`,
					headers: {
						'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
					}
				}).then(res => {

					this.cData = [];
					for(var x in res.data.content) 
						this.cData.push( {"code":x, "cname":res.data.content[x], "select": false} )

				}).catch(err => {
					console.log(err)
				})
			},			
			checkCountry: function(cName, check){

				for( var x in this.cData )
					if(this.cData[x].cname==cName) this.cData[x].select = check;

			},	
			checkCode: function(code, check){

				for( var x in this.keyLists ){
					if(this.keyLists[x].code==code) this.keyLists[x].select = check;
				}
				this.error.keycode = !this.keyLists.filter(x=>x.select).length;
			},	
			selCountryAll: function(){
				for( var x in this.cData )
					this.cData[x].select = true;
			},
			unSelCountryAll: function(){
				for( var x in this.cData )
					this.cData[x].select = false;
			},
			selWGroupsAll:function(){
				this.wgData.map(x => x.select = true);
			},
			unSelWGroupsAll:function(){
				this.wgData.map(x => x.select = false);
			},
			checkGroups:function(name, check){
				for( var x in this.wgData)
					if(this.wgData[x].name==name) this.wgData[x].select = !check;
			},
			getUsers: function(){
				this.axios.request({
					method: 'post',
					url: `${apiDomain}/api/v1/users/whitelist`,
					data: {token: this.$cookies.get('token')},
					headers: {
						'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
					}
				}).then(res => {
					debugger				
					this.wgData = res.data.data.map( x => {x['select'] = true; return x;});

				}).catch(err => {
					console.log(err)
				})				
			},			
		},
		watch: {				
			searchKeys: function(keys){

				if(keys.length == 2){
					
					this.loadingAPI = true;
					this.axios.request({
						method: 'get',
						url: `${apiDomain}/api/v1/search/games/${keys}`,					
					}).then(res => {
						
						this.loadingAPI = false;
						
						var gmData = [];	
											
						for (var i in res.data.data){
							if( res.data.data[i] && (res.data.data[i].free_2_play == 'false') && (res.data.data[i].status != 'inactive') ) gmData.push(res.data.data[i])
						}

						if(!gmData.length) 
							this.error.selectGameError = "Not results";
						else
							this.error.selectGameError = false;

						gmData.map((x,i)=>{

							x.game_logo   = `https://cdn${(i+1)%16}.idcgames.com/storage/image/${x.id_idcgame}/game_logo/2x1_1-8_0.png`;
							x.game_banner = `https://cdn${(i+1)%16}.idcgames.com/storage/image/${x.id_idcgame}/game_banner/2x1_1-4_72.jpg`;
							return x;					
						});
						
						//
						let gbl = this;
						gmData.forEach( (x, i) => {

								let redeem = gbl.redeemGamedata.filter( xx => xx.id_idcgame == x.id_idcgame );

								if(redeem.length){
									
									let arr = [];
									redeem.forEach((xxx, ii) => {
										xxx.KeyIdc.map( y => arr.push(y) );
									});

									gmData[i]["KeyIdc"] = arr;
								}else{
									gmData[i]["KeyIdc"] = [];
								}

								gmData[i]["price"] = JSON.parse(x.price);
								gmData[i]["value_type"] = 'full';
							}
						);

						//init
						this.orgGamedata = gmData;
						this.drawGamedata = this.orgGamedata;
						
	
						if(gmData.length){
							this.showTbl = true;
							this.error.selectGameError = false;
						}else{
							this.showTbl = false;
							this.error.selectGameError = 'Not results';
						}
	
					}).catch(err => {
						console.log(err)
					})
				}else if(keys.length > 2){

					this.drawGamedata = this.orgGamedata.filter(x => x.game_name.toLowerCase().includes(keys.toLowerCase()));
					
					if(this.drawGamedata.length){
						this.showTbl = true;
						this.error.selectGameError = false;
					}else{
						this.showTbl = false;
						this.error.selectGameError = 'Not results';
					}
				}
			},	
			searchCountries: function(keys){
				let nLen = this.cData.filter(x=> (x.cname + x.code).toLowerCase().includes(keys.toLowerCase()) ).length;
				this.error.selectCountryError = !nLen ? 'Not results' : '';
			},
			cData: function(){
			},			
			whocanenter: function(ss){
			},										
			sDate: function(val){
				if(this.sDate >= this.eDate){ 
					this.error.dateRanger = true; 
				}else{
					this.error.dateRanger = false; 
				}
			},
			eDate: function(val){
				if(this.sDate >= this.eDate){ 
					this.error.dateRanger = true; 
				}else{
					this.error.dateRanger = false; 
				}
			},
		},
		computed: {			
		},
		created: function() {
			//
			this.loadingAPI = true;
			this.axios.request({
				method: 'post',
				url: `${apiDomain}/api/v1/search/games`,
				data: {token: this.$cookies.get('token')},
				headers: {
					'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
				}
			}).then(res => {
				
				this.loadingAPI = false;

				var gData = [];		
								
				for (var i in res.data.data){
					if( res.data.data[i] && (res.data.data[i].free_2_play == 'false') && (res.data.data[i].status != 'inactive') ) gData.push(res.data.data[i])
				}

				gData.map((x,i)=>{
					let lFmt = x.img_format.logo_fmt;
					let bFmt = x.img_format.banner_fmt;
					
					x.game_logo   = `https://cdn${(i+1)%16}.idcgames.com/storage/image/${x.id_idcgame}/game_logo/2x1_1-8_0.${lFmt}`;
					x.game_banner = `https://cdn${(i+1)%16}.idcgames.com/storage/image/${x.id_idcgame}/game_banner/2x1_1-4_72.${bFmt}`;
					return x;					
				});
				this.redeemGamedata = gData;
				this.$store.commit('addGames', gData);

			}).catch(err => {
				this.loadingAPI = false;						
			})

			//get users list
			this.getUsers();
		}		
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.hero_section{
		display: flex;
		justify-content: center; 
		align-items: center;

		@at-root #{&}__img_link {
			margin-right: 25px;
			background-color: rgba(0,0,0,0.2);
			border-left-color: transparent;
			border-top-color: transparent;
			box-shadow: 3px 3px 4px #0000002e;
			padding: 10px;

			img{
				width: 100%;
				max-width: 500px;
				max-height: 215px;
			}
		}

		@at-root #{&}__summary {
			flex: 1;

			.summary_columns{
				display: flex;

				.summary__column{
					min-height: 26px;
					white-space: nowrap;
					color: rgba(255,255,255,0.6);
					border-radius: 4px;
					font-size: 11px;
					border: 1px solid rgba(255,255,255,0.1);
					line-height: 26px;
					padding: 0 8px;

					&:nth-child(2){
						flex: 1;
						margin-left: 0.5rem;
						margin-right: 0.5rem;
					}
				}

                .giveaway__columns{
                    &__contributor-level{
                        border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
                        color: rgba(166,93,92,0.95) !important;
                        background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
                        white-space: nowrap;
                        border-radius: 4px;
                        font-size: 11px;
                        border: 1px solid #d2d6e0;
                        line-height: 30px;
                        padding: 0 8px;
                        margin-right: 0.5rem;
                    }
                }
			}
		}
	}

    .markdown_description p{
        margin-bottom: 1rem;
    }

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
			    cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: flex;
				justify-content: space-between;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;
				margin-right: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
                    margin-right: 5px;
                    margin-top: -1px;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

    .comments{
		.comment{
			margin: 1rem 0;
			border-bottom: 1px solid $color__gray--darker;

			&:last-child{
				border-bottom: none;
			}

			&__parent, &__child, &__entity{
				max-width: 850px;
				display: flex;
			}

			&__children{
				margin-left: 50px;
			}

			.global__image-outer-wrap--avatar-small{
				height: 32px;
				width: 32px;
			}

			&__child{
				border: 1px solid $color__lightgray--primary;
				border-radius: 4px;
				padding: 15px;
			}

			&__actions{
				display: flex;
			}

			.global__image-outer-wrap--avatar-small{
				margin-right: 10px;
			}

			&__children:not(.comment__children--no-indent){
				padding-left: 25px;
				border-left: 1px solid #d2d6e0;
			}

			.giveaway_image_avatar{
				margin-right: 1rem;
			}

			&__summary{
                padding-bottom: 0.5rem;

				.comment__author{
					color: $color__green--primary;
					margin-bottom: 5px;
					display: flex;

					svg{
						margin-top: -1px;
						margin-right: 0.5rem;

						&:focus, &:hover{
							cursor: pointer;
							outline: none;
						}
					}
				}
			}
			.nav__avatar-inner-wrap, .global__image-inner-wrap{
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				height: 100%;
				width: 100%;
				border-radius: 2px;
			}
		}
	}

	.table{
		width: 100%;
		margin-bottom: 1rem;
		color: #212529;
		
		.table__heading {
			display: flex;
			min-height: 32px;
			align-items: center;
			font-size: 11px;
			margin-top: 1rem;
			margin-bottom: 1rem;
			font-weight: bold;
			color: #fff;
			border-bottom: 1px solid $color__green--darker;

			.table__column--width{

				&-fill{
					flex: 1;
				}
				&-small{
					width: 13%;
					min-width: 90px;
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}

		.table__row-inner-wrap{
			display: flex;
			align-items: center;
			line-height: 1.3em;
			color: #fff;
			padding: 10px 0;
			font-size: 14px;
			cursor: pointer;

			&:not(:last-child){
				border-bottom: 1px solid #d2d6e0;
			}

			.table__column--width{

				&-fill{
					flex: 1;
					margin-left: 15px;
				}
				&-small{
					width: 13%;
					min-width: 90px;

					svg{
						color: $color__green--darker;
					}
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}
		
	}

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
	.redborder{ cursor: pointer;}
	#my-table{
		color: white;
	}
	#country-container{
		max-height: 50vh;
		overflow: auto;
	}
	.slt, .slt:focus, .slt:focus-visible{ border: none; box-shadow: none; outline: none;}
	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;			
			.table{
				overflow-x: auto;
				
				.table__row-inner-wrap, .table__heading{
					min-width: 800px;
				}
			}
		}
		.threads_main__side_bar {
			display: none;
		}
		.threads_main__threads {
			width: 100%;
			margin-left: 0;
		}
		.hero_section{
			display: block;
			text-align: center;
		}
	}
</style>
<style>
.review-label{
	background: #314954;
    width: 100%;    
}
.border-danger{
	border: 2px solid red!important;
}
</style>
